import script from "./ClientList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientList.vue?vue&type=script&setup=true&lang=js"

import "./ClientList.vue?vue&type=style&index=0&id=f0411da2&lang=scss&scoped=true"
import "./ClientList.vue?vue&type=style&index=1&id=f0411da2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0411da2"]])

export default __exports__